"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var objToQuery_1 = __importDefault(require("./objToQuery"));
function api(endpoint, data, method) {
    if (data === void 0) { data = null; }
    if (method === void 0) { method = 'GET'; }
    var query = (data) ? (0, objToQuery_1.default)(data) : null;
    var url = endpoint;
    if (method === 'GET' && query) {
        url = "".concat(url, "?").concat(query);
    }
    return fetch(url, {
        method: method,
        body: (method === 'GET') ? null : query,
        credentials: 'same-origin',
        headers: {
            Accept: 'application/json',
        },
    })
        .then(function (response) {
        if (response.status > 299) {
            throw new Error(response.statusText);
        }
        return response;
    })
        .then(function (response) { return response.json(); })
        .then(function (json) {
        if (json.http_code && parseInt(json.http_code, 10) > 299) {
            throw new Error('Unexpected response');
        }
        return json;
    });
}
exports.default = api;
//# sourceMappingURL=api.js.map